module.exports = __webpack_public_path__ + "c25eede6fb4a3358cdfa1db9f150ccce.svg";


//////////////////
// WEBPACK FOOTER
// ./images/space_business.svg
// module id = ./images/space_business.svg
// module chunks = 5